import React, { useEffect, useState } from "react";
import classnames from "classnames";

import { PullRight } from "../../../../components/layout/pull-right/pull-right.styles";

import { AddContentButton } from "../../../common-attributes/components/add-remove-content/add-content-button";
import { RemoveContentButton } from "../../../common-attributes/components/add-remove-content/remove-content-button";

import { useFieldsStyles } from "../../fields/fields.styles";
import { FieldToggleProps } from "./field-toggle.props";

export const FieldToggle = (props: FieldToggleProps) => {
  const { addButtonText = "Add", openByDefault = false } = props;
  const classes = useFieldsStyles();

  const [isOpen, setIsOpen] = useState<boolean>(openByDefault);

  useEffect(() => {
    setIsOpen(openByDefault);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const close = () => {
    props.setValue(props.name, "");
    setIsOpen(false);
  };

  const open = () => setIsOpen(true);

  const childrenWrapperClasses = classnames({
    [classes.hidden]: !isOpen && props.use,
  });

  const showAdd = !isOpen && props.use;
  const showRemove = isOpen && props.use && props.canEdit;

  return (
    <>
      <PullRight showIf={showRemove}>
        <RemoveContentButton buttonText="remove" onClick={close} />
      </PullRight>

      <AddContentButton
        showIf={showAdd}
        buttonText={addButtonText}
        disabled={!props.canEdit}
        onClick={open}
      />

      <div className={childrenWrapperClasses}>{props.children}</div>
    </>
  );
};
